// @flow
/* -----------------Globals--------------- */
import React from 'react';

/* -----------------UI--------------- */
import {
  Container,
  Box,
} from '@material-ui/core';

/* -----------------Utils--------------- */
import { renderItems } from './utils';

/* -----------------Child components--------------- */
import AppContentHeaderSkeleton from './AppContentHeaderSkeleton';
import TermCardSkeleton from './TermCardSkeleton';

/* -----------------Component--------------- */
const StudySetDetailsSkeleton = () => (
  <>
    <AppContentHeaderSkeleton />
    <Container maxWidth="lg">
      <Box py={6}>
        {renderItems(8, <TermCardSkeleton />)}
      </Box>
    </Container>
  </>
);
export default StudySetDetailsSkeleton;
